import _slicedToArray from "/codebuild/output/src182831320/src/scottschedule/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest as s } from "tslib";
import e from "classnames";
import * as o from "react";
import { ComponentClassNames as a } from "../shared/constants.js";
import { ShowPasswordButton as t } from "./ShowPasswordButton.js";
import { TextField as r } from "../TextField/TextField.js";
var l = o.forwardRef(function (l, d) {
  var _l$autoComplete = l.autoComplete,
    w = _l$autoComplete === void 0 ? "current-password" : _l$autoComplete,
    n = l.label,
    i = l.className,
    _l$hideShowPassword = l.hideShowPassword,
    p = _l$hideShowPassword === void 0 ? !1 : _l$hideShowPassword,
    m = l.passwordIsHiddenLabel,
    u = l.passwordIsShownLabel,
    b = l.showPasswordButtonLabel,
    c = l.showPasswordButtonRef,
    h = l.size,
    f = s(l, ["autoComplete", "label", "className", "hideShowPassword", "passwordIsHiddenLabel", "passwordIsShownLabel", "showPasswordButtonLabel", "showPasswordButtonRef", "size"]);
  var _o$useState = o.useState("password"),
    _o$useState2 = _slicedToArray(_o$useState, 2),
    P = _o$useState2[0],
    L = _o$useState2[1],
    S = o.useCallback(function () {
      L("password" === P ? "text" : "password");
    }, [L, P]);
  return o.createElement(r, Object.assign({
    autoComplete: w,
    isMultiline: !1,
    outerEndComponent: p ? null : o.createElement(t, {
      fieldType: P,
      onClick: S,
      passwordIsHiddenLabel: m,
      passwordIsShownLabel: u,
      ref: c,
      size: h,
      showPasswordButtonLabel: b
    }),
    size: h,
    type: P,
    label: n,
    className: e(a.PasswordField, i),
    ref: d
  }, f));
});
l.displayName = "PasswordField";
export { l as PasswordField };